//
//
//
//
//
//
//

export default {
  name: "App",
  created: function created() {
    var w = window.screen.width;
    var cWidth = parseInt(w / 1920 * 16);
    document.querySelector("html").style.fontSize = cWidth + "px";
  },
  mounted: function mounted() {},
  methods: {}
};